import React, { Component } from 'react';
import Typography from '../Typography/Typography';
import ReactToPrint from "react-to-print";
import GridItem from "components/Grid/GridItem.jsx";
import print_logo from '../../assets/img/print_logo.jpg';
import GridContainer from "components/Grid/GridContainer";
import Button from "components/CustomButtons/Button";
import urlConstants from '../../variables/urlConstants';
import axios from "axios";

class Timeline extends Component {
  constructor(props) {
    super(props);

    let vin = '';
    if (window.location.hash && window.location.hash.split('?')[1]) {
      let searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
      vin = searchParams.get('vin');
    }

    this.state = {
      selectedVin: vin,
      refreshTimeline: false,
    }
  }

  componentDidMount() {
    this.openDetails(this.state.selectedVin);
  }

  getVehicleDetails(vin) {
    return axios.get(urlConstants.BASE_URL + '/vehicle/vin?vin=' + encodeURIComponent(vin))
      .then(res => {
        return res;
      });
  }

  openDetails(vin) {
    vin = vin.toUpperCase();
    this.setState({
      customerInfo: null
    });
    return this.getVehicleDetails(vin)
      .then(res => {
        if (res.data.Item) {
          this.setState({
            details: res.data.Item.details,
            selectedVin: vin,
            licenseNum: res.data.Item.licenseNum,
            miles: res.data.Item.miles
          });
          axios.get(urlConstants.BASE_URL + '/' + this.props.type + '/lookupById?userId=' +
            encodeURIComponent(res.data.Item.owner) + '&type=unknown')

            .then(res => {
              if (res.data.Item) {
                this.setState({
                  customerInfo: res.data.Item
                });
              }
            });
        } else if (res.data.Items) {
          if (res.data.Items.length === 1) {
            this.setState({
              details: res.data.Items[0].details,
              selectedVin: res.data.Items[0].vin
            });
            axios.get(urlConstants.BASE_URL + '/' + this.props.type + '/lookupById?userId=' +
              encodeURIComponent(res.data.Items[0].owner) + '&type=unknown')
              .then(res => {
                if (res.data.Item) {
                  this.setState({
                    customerInfo: res.data.Item
                  });
                }
              });
          }
        }
      })
      .catch(err => {
        if (err && err.response && err.response.status === 404) {
          this.setState({
            vinChoiceList: ["No data found for this vin"]
          })
        }
      })
  }

  render() {
    return (
      <div>
        <div style={{ margin: '40px 40px 0 40px' }}>
          <GridContainer>
            <GridItem className="car_infogrid">
              <div className="loop_info"><b>VIN:</b> {this.state.selectedVin}</div>
              <div className="loop_info"><b>Details:</b> {this.state.details ? this.state.details : <span style={{color: "red", fontWeight: 'bold'}}>Missing (Not B.A.R. compliant)</span>}</div>
              <div className="loop_info"><b>License Number:</b> {this.state.licenseNum ? this.state.licenseNum : <span style={{color: "red", fontWeight: 'bold'}}>Missing (Not B.A.R. compliant)</span>}</div>
              {this.state.customerInfo &&
                <div className="botton_info">
                  <div className="loop_info"><b>Customer Name:</b> {this.state.customerInfo.name}</div>
                  <div className="loop_info"><b>Customer Email:</b> {this.state.customerInfo.email}</div>
                  <div className="loop_info"><b>Customer Phone:</b> {this.state.customerInfo.phoneNumber ? this.state.customerInfo.phoneNumber :
                    <span style={{color: "red", fontWeight: 'bold'}}>Missing (Not B.A.R. compliant)</span>}</div>
                  <div className="loop_info"><b>Customer Address:</b> {this.state.customerInfo.address ? this.state.customerInfo.address :
                    <span style={{color: "red", fontWeight: 'bold'}}>Missing (Not B.A.R. compliant)</span>}</div>
                </div>
              }
              {!this.state.customerInfo &&
                <p>No customers found for this vehicle.</p>
              }
            </GridItem>
            <GridItem className="car_infogrid img">
                  <img src={urlConstants.BASE_URL + '/vehicle/vehicleIcon?vin=' + this.state.selectedVin} alt="vehicle icon" width="auto"
                       height="auto" style={{maxHeight: 150, maxWidth: 350, borderRadius: "20px"}} />
            </GridItem>
          </GridContainer>
        </div>
        <div style={{overflow: 'auto', float: 'left', margin: '8px 40px 40px 40px', maxWidth: '1000px'}}
             className='overflowScroll'>
          <div>
            <ReactToPrint style
                          trigger={() => <input type='image' alt='Print timeline' src={print_logo} width='36' height='36' />}
                          content={() => this.printRef}/>
            <GridItem>
              {this.props.type !== 'user' && this.state.timelineRelease && <p></p>}
              <div ref={elem => this.printRef = elem} style={{float: 'right', width: '95%'}}>
                <Typography style={{float: 'left'}} key={this.state.selectedVin} refresh={this.state.refreshTimeline}
                            vin={this.state.selectedVin} type={this.props.type}/>
              </div>
            </GridItem>
          </div>
        </div>
      </div>
    )
  }
}

export default Timeline;
